import React from "react";
import "./RightImageCardBtn.scss";
import { Link } from "react-router-dom";
export default function RightImageCardBtn(props) {
  return (
    <div className="cardBase">
      <div className="cardContent">
        <div className="cardLeftGrid">
          <div className="textBaseMiddle">
            <h1 className="cardTitleTxtM">{props.title}</h1>
            <p className="cardSubTxt">{props.desp}</p>
            <Link to={props.link} style={{ textDecoration: "none" }}>
              <button className="blueBtn">{props.btnTxt}</button>
            </Link>
          </div>
        </div>
        <div className="cardRightGrid">
          <div className="imgBase">
            <img src={props.img} alt="cardImg" className="cardImg" />
          </div>
        </div>
      </div>
    </div>
  );
}
